import { Component, h, Element, Prop } from "@stencil/core";
import pfx from "../../utils/style-class-prefix-helper";
import { FOOTER_BAR_SHOW_COLOR_SEPARATOR } from "../../constants/global-constants";

/**
 * @slot socialmedia - Holds any number of eon-ui-link elements. Set an icon but no text on these links.
 * @slot links - Holds any number of eon-ui-link elements. Set size to small and provide a text for these links.
 * @slot logo - Holds a single eon-ui-image element
 */
@Component({
  tag: "eon-ui-footer-bar",
  styleUrl: "footer-bar.scss",
  shadow: true
})
export class FooterBar {
  @Element() hostElement: HTMLEonUiFooterBarElement;

  /**
   * A text displayed as copyright notice, next to the logo
   * @example "© E.ON SE 2020"
   */
  @Prop() copyright: string;

  private isSocialMediaSlotUsed = false;

  componentWillLoad() {
    for (let i = 0; i < this.hostElement.children.length; i++) {
      const child = this.hostElement.children[i];
      if (child.tagName.toUpperCase() === "EON-UI-LINK") {
        if (child.getAttribute("slot") === "links") {
          child.setAttribute("hide-icon", "true");
        }
        if (child.getAttribute("slot") === "socialmedia") {
          this.isSocialMediaSlotUsed = true;
        }
      }
      if (child.tagName.toUpperCase() === "EON-UI-IMAGE") {
        child.setAttribute("use-as-background", "false");
        child.setAttribute("width", "100px");
        child.removeAttribute("aspect-ratio");
      }
    }
  }

  render() {
    return (
      <footer aria-label={"footer-bar"}>
        <div class={pfx("footer-content-wrapper")}>
          <div class={pfx("footer-wrapper")}>
            <div class={pfx("link-content")}>
              {this.isSocialMediaSlotUsed && (
                <div class={pfx("socialmedia")}>
                  <slot name="socialmedia"></slot>
                </div>
              )}
              <div class={pfx("links")}>
                <slot name="links"></slot>
              </div>
            </div>
            <div class={pfx("logo-content")}>
              {this.copyright && (
                <div class={pfx("copyright-content")}>
                  <span class={pfx("copyright")} innerHTML={this.copyright}></span>
                </div>
              )}
              <div class={pfx("logo")}>
                <slot name="logo"></slot>
              </div>
            </div>
          </div>
        </div>
        {!!FOOTER_BAR_SHOW_COLOR_SEPARATOR && <eon-ui-color-separator></eon-ui-color-separator>}
      </footer>
    );
  }
}
